<template>
  <q-page-sticky
    v-if="DEV"
    position="bottom-right"
    :offset="[18, 18]"
    class="z-[99999999]"
  >
    <q-card v-if="config.showFloatCard">
      <div class="flex items-center justify-between">
        <p class="text-caps-2 text-neutral-60 px-8 pt-16">
          Dev Tricks
        </p>
        <OButton
          rounded
          icon="close"
          @click="config.showFloatCard = !config.showFloatCard"
        />
      </div>
      <q-item
        class="items-center gap-8 select-none text-paragraph-3"
        tag="label"
      >
        <q-toggle
          v-model="config.cache.persistent"
          size="lg"
        />
        <p>Axios Cache Persistent</p>
      </q-item>
      <q-item
        class="items-center gap-8 select-none text-paragraph-3"
        tag="label"
      >
        <q-toggle
          v-model="config.cache.clearOnMutation"
          size="lg"
        />
        <p>Limpar Cache em Mutação</p>
      </q-item>
      <q-item
        class="items-center gap-8 select-none text-paragraph-3"
        tag="label"
      >
        <q-toggle
          v-model="config.persticide"
          size="lg"
        />
        <p>Bordas Layout</p>
      </q-item>
    </q-card>
    <OButton
      v-else
      class="shadow-lg"
      secondary
      icon="code"
      rounded
      @click="config.showFloatCard = !config.showFloatCard"
    />
  </q-page-sticky>
</template>

<script setup>
import { DEV } from 'js/utils/constants/app'
import { useDevTricks } from 'composables/useDevTricks'
import OButton from 'components/Button/OButton.vue'
const { config } = useDevTricks()


</script>

<style lang="scss" scoped></style>
